import {
  customInstance
} from "./chunk-PXAHF6KP.js";

// generated/search-bff/controllers/listing-property-search/listing-property-search.ts
var searchListings = (searchFilterRequest, params, options) => {
  return customInstance(
    {
      url: `/api/v2/listing/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchFilterRequest,
      params
    },
    options
  );
};
var listPropertiesForMap = (searchFilterRequest, params, options) => {
  return customInstance(
    {
      url: `/api/v2/listing/search/geopoints`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchFilterRequest,
      params
    },
    options
  );
};
var listPropertiesForMap1 = (searchFilterRequest, options) => {
  return customInstance(
    {
      url: `/api/v1/admin/listing/search/geopoints`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchFilterRequest
    },
    options
  );
};
var getListingById = (listingIdOrDisplayId, params, options) => {
  return customInstance(
    {
      url: `/api/v2/listing/${listingIdOrDisplayId}`,
      method: "GET",
      params
    },
    options
  );
};

export {
  searchListings,
  listPropertiesForMap,
  listPropertiesForMap1,
  getListingById
};
